import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import objectHelpers from '../../utilities/objectHelpers';
import Select from 'react-select'
import DropdownMultiselect from 'react-multiselect-dropdown-bootstrap';
import { useImmer } from 'use-immer';

const WAIT_INTERVAL = 500;

const Multiselect = React.memo((props) => {

    const [localSelectedValues, setLocalSelectedValues] = useImmer([]);
    const [indexedOptions, setIndexedOptions] = useImmer([]);

    const touched = objectHelpers.get(props.formHandler.touched, props.name) != undefined;
    const errors = objectHelpers.get(props.formHandler.errors, props.name);
    const formikValue = objectHelpers.get(props.formHandler.values, props.name)??[];
    let className = props.className ? 'search-select' + props.className : 'search-select';
    className = touched && errors ? 'is-invalid ' + className : className;

    useEffect(() => {
        const indexedOpts = [];
        props.options.forEach(el => {
            if (el.options) {
                el.options.forEach(cel => {
                    indexedOpts[cel.value] = cel;
                })
            } else {
                indexedOpts[el.value] = el;
            }
        });
        setIndexedOptions(indexedOpts);
    }, [props.options])

    useEffect(() => {
        if (props.handleChange) {
            let localSelected = [];
            formikValue.forEach(val => {
                if (indexedOptions[val.value]) {
                    localSelected.push(val);
                }
            })
            setLocalSelectedValues(localSelected);
        } else {
            setLocalSelectedValues(props.options.filter(x => formikValue.includes(x.value)));
        }
    }, [formikValue])

    const handleChange = (selected, action) => {
        if (props.handleChange) {
            //const tmpVals = localSelectedValues.map(x => parseInt(x.value));
            let ev = { target: { name: props.name, value: selected } }
            props.handleChange(ev);
        }
        else {
            const tmpVals = selected.map(x => parseInt(x.value));

            props.formHandler.setFieldValue(props.name, tmpVals, true)
        }
    };

    const handleBlur = (e) => {
        const tmpVals = localSelectedValues.map(x => parseInt(x.value));
        let ev = { target: { name: props.name, value: tmpVals } }
        props.formHandler.handleBlur(ev)
    }

    return (
        <>
            <Form.Label disabled={props.disabled} className={props.label ?? "d-none"}>{props.label}</Form.Label>
            {/*JSON.stringify(formikValue, null, 2)*/}
            <Select
                className={className}
                options={props.options}
                name={props.name}
                isDisabled={props.disabled}
                isMulti="true"
                isSearchable="true"
                classNamePrefix="search-select"
                placeholder={props.placeholder ? props.placeholder : "Select..."}
                value={localSelectedValues}
                onChange={(selected, action) => {
                    handleChange(selected);
                }}
                onBlur={(e) => handleBlur(e)}
                isInvalid={touched && errors}
            />
            <Form.Control.Feedback disabled={props.disabled} type="invalid">{errors}</Form.Control.Feedback>
        </>
    );
})

export default Multiselect;